module.exports = __webpack_public_path__ + "img/unither-logo-full.8fb54e69.png";